// 一些全局的config配置
const modeUrlObj = {
  'production': {
    baseURL: `/new-generation-api`
    // baseURL: 'http://10.1.149.146/new-generation-api',
    // authBaseURL: `${location.origin}/newmail-api`,
    // wxauthBaseURL: 'http://xinweixin.11183.com.cn'
  },

  'development': {
    // baseURL: '/newmail/api'
    baseURL: `/new-generation-api-dev`
    // baseURL: `/new-generation-api-dev`
    // baseURL: 'https://wx.emspost.com.cn/newmail/api',
    // authBaseURL: 'https://wx.emspost.com.cn/weixin/newmail-api'
    // baseURL: 'http://172.17.71.79/new-generation-api',
    // authBaseURL: 'https://ems.emspost.com.cn/newmail-api'
  },
  /*   'development': {
    baseURL: `/new-generation-api-dev`,
    authBaseURL: `${location.origin}/newmail-api`
  }, */
  'test': {
    baseURL: '/newmail/api'
    // authBaseURL: `${location.origin}/weixin/newmail-api`,
    // baseURL: 'https://ems.emspost.com.cn/new-generation-api',
    // authBaseURL: 'https://ems.emspost.com.cn/newmail-api'
    // wxauthBaseURL: 'https://wx.emspost.com.cn/weixin'
  },
  'release': {
    baseURL: `/new-generation-api-dev`
    // authBaseURL: `${location.origin}/newmail-api`,
    // wxauthBaseURL: 'http://xinweixin.11183.com.cn'
  }
}
const RESOURCES_URL_OBJ = {
  'development': '/newmail-resources/release',
  'test': '/weixin/newmail-resources',
  'release': '/newmail-resources/release',
  'production': '/newmail-resources'
}
export const RESOURCES_URL = RESOURCES_URL_OBJ[process.env.VUE_APP_NODE_ENV]
export default modeUrlObj[process.env.VUE_APP_NODE_ENV]
